import React, { useState } from "react";
import Drawer from "./Drawer";
import { CloseButton } from "./Bits";
import { AI_SUGGESTIONS } from "../data/mockData";

/**
 * AI Copilot slide-over. Approve/Dismiss are local-only — they record the
 * decision in component state and swap the buttons for a tag, exactly as the
 * prototype does. No request is made.
 */
const AiCopilotDrawer = ({ onClose }) => {
  const [decisions, setDecisions] = useState({});

  const decide = (id, verdict) =>
    setDecisions((prev) => ({ ...prev, [id]: verdict }));

  return (
    <Drawer onClose={onClose} narrow labelledBy="ai-copilot-title">
      <div className="admin-drawer-head">
        <h4 id="ai-copilot-title" style={{ margin: 0 }}>AI Copilot</h4>
        <CloseButton onClick={onClose} label="Close AI Copilot" />
      </div>

      <p style={{ fontSize: 12, opacity: 0.7, margin: "6px 0 18px" }}>
        Suggestions surfaced by the platform's agentic ops framework, scanning
        payments, entitlements and verification state.
      </p>

      <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
        {AI_SUGGESTIONS.map((s) => {
          const verdict = decisions[s.id];
          return (
            <div className="card" key={s.id}>
              <div className="card-kicker" style={{ color: "var(--color-accent-300)" }}>{s.area}</div>
              <div className="card-title" style={{ fontSize: 14 }}>{s.title}</div>
              <p className="card-body" style={{ fontSize: 12 }}>{s.detail}</p>

              {!verdict && (
                <div style={{ display: "flex", gap: 8 }}>
                  <button type="button" className="btn btn-primary" onClick={() => decide(s.id, "approved")}>
                    Approve
                  </button>
                  <button type="button" className="btn btn-secondary" onClick={() => decide(s.id, "dismissed")}>
                    Dismiss
                  </button>
                </div>
              )}
              {verdict === "approved" && <span className="tag tag-accent">Approved</span>}
              {verdict === "dismissed" && <span className="tag tag-neutral">Dismissed</span>}
            </div>
          );
        })}
      </div>
    </Drawer>
  );
};

export default AiCopilotDrawer;
